<template>
    <div class="header-top">
        <system-bar-part />
        <v-card class="mx-auto overflow-hidden card-heder" height="auto">
            <v-app-bar dense>
                <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = true"></v-app-bar-nav-icon>

                <v-toolbar-title><router-link to="/">Аренда Авто </router-link></v-toolbar-title>
                <v-spacer />

                <div class="text-center" v-if="GET_IS_LOGGET">
                    <v-menu :close-on-content-click="false" :nudge-width="200" offset-x max-width="300">

                        <template v-slot:activator="{ on, attrs }">
                            <UserPreviewPart :attr="attrs" :on="on" :downClass="'hidden-sm-and-down'" />
                        </template>

                        <v-card>
                            <v-list>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>Настройки</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>

                            <v-divider></v-divider>

                            <v-list>
                                <v-list-item>
                                    <v-list-item-action>
                                        <v-switch v-model="this.$vuetify.theme.dark" @change="setTheme" color="purple" />
                                    </v-list-item-action>
                                    <v-list-item-title>Тёмная тема</v-list-item-title>
                                </v-list-item>

                                <v-list-item v-for="link in linksDesctop" link :to="link.url" :key="link.url">
                                    <v-list-item-icon>
                                        <svg-icon type="mdi" :path="link.icon" />
                                    </v-list-item-icon>

                                    <v-list-item-content>
                                        <v-list-item-title>{{ link.name }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider />
                                <v-list-item @click="logout">
                                    <v-list-item-icon>
                                        <svg-icon type="mdi" :path="$data.icons.exit" />
                                    </v-list-item-icon>

                                    <v-list-item-content>
                                        <v-list-item-title>Выход</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>

                            </v-list>
                        </v-card>
                    </v-menu>
                </div>
            </v-app-bar>

        </v-card>
        <v-navigation-drawer v-model="drawer" absolute temporary>
            <UserPreviewPart :attr="false" :on="false" :downClass="'hidden-md-and-up'"/>
            <v-divider></v-divider>

            <v-list nav dense>

                <v-list-item-group v-model="group" active-class="deep-purple--text text--accent-4">

                    <v-list-item v-for="link in linksDrower" :key="link.name" link :to="link.url">
                        <v-list-item-icon>
                            <svg-icon type="mdi" :path="link.icon" />
                        </v-list-item-icon>
                        <v-list-item-title>{{link.name}}</v-list-item-title>
                    </v-list-item>

                    <v-divider />

                    <v-list-item @click="logout">
                        <v-list-item-icon>
                            <svg-icon type="mdi" :path="$data.icons.exit" />
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Выход</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                </v-list-item-group>

            </v-list>
            <v-spacer />

            <v-list-item @click="setTheme" class="theme-btn-drawer">
                <svg-icon type="mdi" :path="$data.icons.television" />
            </v-list-item>

        </v-navigation-drawer>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import UserPreviewPart from "./parts/UserPreviewPart";
import SystemBarPart from "./parts/SystemBarPart";
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiAccountPlusOutline, mdiPlusBoxMultipleOutline, mdiAccountConvertOutline, mdiDomain, mdiBellRing, mdiAlarmPlus,
    mdiClipboardListOutline, mdiRoomServiceOutline, mdiAccountPlus, mdiPlusBoxMultiple, mdiExitRun, mdiTelevision,

} from '@mdi/js'

export default {
    name: 'HeaderComponent',
    components: {
        UserPreviewPart,
        SystemBarPart,
        SvgIcon
    },
    data: () => ({
        icons: {
            exit: mdiExitRun,
            television: mdiTelevision,
        },
        drawer: false,
        group: null,
        value: 1,
        linksDrower: [
            {name: 'Главная', url: '/', icon: 'mdi-home'},
            {name: 'Добавить сотрудника', url: '/auth/create', icon: mdiAccountPlusOutline},
            {name: 'Добавить машину', url: '/car/create', icon: mdiPlusBoxMultipleOutline},
            {name: 'Доб/Ред Клиента', url: '/client/new-client', icon: mdiAccountConvertOutline},
            {name: 'Доб/Ред Компании', url: '/client/add-company', icon: mdiDomain},
            // {name: 'Оформить Заказ', url: '/new-order', icon: 'mdi-bookmark-outline'},
            {name: 'Aктивные заказы', url: '/order/active/list', icon: mdiBellRing},
            {name: 'Бронирование', url: '/booking', icon: mdiAlarmPlus},
            {name: 'Список машин', url: '/car/car-list', icon: mdiClipboardListOutline},
            {name: 'Обслуживание', url: '/services/add', icon: mdiRoomServiceOutline},
        ],
        linksDesctop: [
            {name: 'Добавить сотрудника', url: '/auth/create', icon: mdiAccountPlus},
            {name: 'Добавить машину', url: '/car/create', icon: mdiPlusBoxMultiple},
            {name: 'Доб/Ред Клиента', url: '/client/new-client', icon: mdiAccountConvertOutline},
            {name: 'Доб/Ред Компании', url: '/client/add-company', icon: mdiDomain},
        ]
    }),
    computed: {
        ...mapGetters(['GET_IS_LOGGET'])
    },
    methods: {
        ...mapActions(['A_LOGOUT']),
        setTheme () {
            this.$store.dispatch('A_SET_THEME', this.$vuetify.theme.dark = !this.$vuetify.theme.dark);
        },

        logout () {
            this.A_LOGOUT();
        }
    }
}
</script>

<style scoped>
header { height: 60px!important; }
.v-toolbar__title{ width: 200px }
.card-heder{ border-radius: inherit; }
.theme-btn-drawer{ position: absolute; bottom: 0; }
@media print {
    .header-top {
        display: none;
    }
}

</style>
